import { render, staticRenderFns } from "./llxjyypt.vue?vue&type=template&id=687f1f66&scoped=true&"
import script from "./llxjyypt.vue?vue&type=script&lang=js&"
export * from "./llxjyypt.vue?vue&type=script&lang=js&"
import style0 from "./llxjyypt.vue?vue&type=style&index=0&id=687f1f66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f1f66",
  null
  
)

export default component.exports